import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import AdminService from '../../../services/admin';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import {Link} from "react-router-dom";
import {grey400} from 'material-ui/styles/colors';
import {SUPER_ADMIN} from '../../../services/admin';
import {fetchApp} from '../../../store/apps/actions';
import {FlatButton, Dialog} from "material-ui";
import style from '../../../styles/styles';
import styles from './MediaTypePage.css';
import IconButton from 'material-ui/IconButton';
import MediaTypeFull from "../../../components/media/MediaType/MediaTypeFull/MediaTypeFull";
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {fetchMediaType, deleteMediaType, postMediaTypePicture, deleteMediaTypePicture} from "../../../store/mediatypes/actions";
import {EDIT_MEDIA_TYPE_PAGE, SETTING_PAGE} from "../../../constants/routes";

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400}/>
    </IconButton>
);

export class MediaTypePage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        mediaType: PropTypes.object
    };

    state = {
        mediaTypeToRemove: null,
        openRemoveMediaType: false,
        openRemoveMediaTypePicture: false
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
        this.fetchMediaType();
    }

    // Fetch

    fetchMediaType(appId = null, mediaTypeId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const mediatype = mediaTypeId || this.props.match.params.mediaTypeId;

            if (app && mediatype) {
                this.props.fetchMediaType(app, mediatype)
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    handleDeleteMediaType = (mediatype) => {
        this.setState({
            openRemoveMediaType: true,
            mediaTypeToRemove: this.props.mediaType
        });
    };

    handleCloseMediaType = () => {
        this.setState({
            openRemoveMediaType: false,
            mediaTypeToRemove: null
        });
    };

    deleteMediaTypePicture = () => {
        this.props.deleteMediaTypePicture(this.props.app.id, this.props.mediaType.id);
        this.setState({
            openRemoveMediaTypePicture: false
        });
    };

    deleteMediaType = () => {
        this.props.deleteMediaType(this.props.app.id, this.props.mediatype.id);
        this.props.history.push(SETTING_PAGE.replace(':appId', this.props.app.id));
    };

    renderDeleteMediaTypeDialog(mediaType) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseMediaType}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteMediaType}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveMediaType}
                    onRequestClose={this.handleCloseMediaType}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    Do you really want to remove the media type "{mediaType.name}" ?
                </p>
                }
            </Dialog>
        );
    }

    handleDeleteMediaTypePicture = () => {
        this.setState({
            openRemoveMediaTypePicture: true
        });
    };

    handleCloseMediaTypePicture = () => {
        this.setState({
            openRemoveMediaTypePicture: false
        });
    };

    renderDeleteMediaTypePictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseMediaTypePicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteMediaTypePicture}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveMediaTypePicture}
                    onRequestClose={this.handleCloseType}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    Do you really want to remove the picture ?
                </p>
                }
            </Dialog>
        );
    }
    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.mediaType) {
            return <Loading paper={false}/>;
        } else {
            let menu;
            if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user)) {
                menu = (
                    <IconMenu
                        style={styles.buttons}
                        listStyle={style.list}
                        iconButtonElement={iconButtonElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                        <Link to={EDIT_MEDIA_TYPE_PAGE.replace(':appId', this.props.app.id).replace(':mediaTypeId', this.props.mediaType.id)} >
                            <MenuItem>
                                Edit
                            </MenuItem>
                        </Link>
                        <MenuItem onClick={this.handleDeleteMediaType}>
                            Remove
                        </MenuItem>
                        {this.props.mediaType.picture &&
                        <MenuItem onClick={this.handleDeleteMediaTypePicture}>
                            Remove picture
                        </MenuItem>}
                    </IconMenu>
                );
            } else {
                menu = null;
            }
            return (
                <div>
                    {this.state.openRemoveMediaType && this.renderDeleteMediaTypeDialog(this.state.mediaTypeToRemove)}
                    {this.state.openRemoveMediaTypePicture && this.renderDeleteMediaTypePictureDialog()}
                    <h3 style={style.navigation}>Media Type / Detail - {this.props.app.name}</h3>
                    {menu}
                    <MediaTypeFull app={this.props.app} mediaType={this.props.mediaType} postPicture={this.props.postMediaTypePicture} deletePicture={this.props.deleteMediaTypePicture}/>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.mediaTypes.pending,
        error: state.apps.error,
        mediaType: state.mediaTypes.currentType,
        app: state.apps.currentApplication,
        sending: state.mediaTypes.sending,
        user: state.auth.content
    };

    if (state.mediaTypes.currentType) {
        props.initialValues = state.mediaTypes.currentType;
    }

    return props;
}

export default connect(mapStateToProps, {
    postMediaTypePicture,
    deleteMediaTypePicture,
    deleteMediaType,
    fetchApp,
    fetchMediaType
})(MediaTypePage);



// WEBPACK FOOTER //
// src/containers/mediatypes/MediaTypePage/MediaTypePage.js